module.exports = __webpack_public_path__ + "static/media/img_add_news_patient.336216cb.svg";